import React from 'react'

function Spinner() {
  return (
 <div className='absolute right-2/4 top-2/4'>
      
<div className="spinner"></div>

 </div>
  )
}

export default Spinner